export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const SYNCHRONIZATION_STARTED = 'SYNCHRONIZATION_STARTED';
export const ADD_SYSTEM_NOTIFACTION = 'ADD_SYSTEM_NOTIFACTION';
export const ADD_SYSTEM_NOTIFICATION_LIST = 'ADD_SYSTEM_NOTIFICATION_LIST';
export const SEND_SYSTEM_NOTIFICATION_REQUESTED = 'SEND_SYSTEM_NOTIFICATION_REQUESTED';
export const SEND_SYSTEM_NOTIFICATION_SUCCEEDED = 'SEND_SYSTEM_NOTIFICATION_SUCCEEDED';
export const SEND_SYSTEM_NOTIFICATION_FAILED = 'SEND_SYSTEM_NOTIFICATION_FAILED';



// WEBPACK FOOTER //
// ./src/services/systemNotifications/actionTypes.js